import React from 'react';

interface ErrorStateProps {
  title: string;
  description: string;
  onPress?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  description,
  onPress,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl border border-gray-200">
      <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mb-4">
        <span className="text-red-500 font-bold text-xl">!</span>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 mb-6 text-center max-w-sm">{description}</p>
      {onPress && (
        <button
          type="button"
          onClick={onPress}
          className="px-4 py-2 bg-pos-primary text-white rounded-lg hover:bg-pos-secondary transition-colors"
        >
          Retry Loading
        </button>
      )}
    </div>
  );
};
